import ConvenioPagos from "./ConvenioPagos.vue";

export {ConvenioPagos}
export default ConvenioPagos
